/**
 * Sidebar view component that can be added either to the body or inside individual elements
 * Important setup note: sidebar element must have a .pusher element as a sibling.
 * If inserting sidebar into the body, then .pusher must also be under body tag.
 */
define('uikit/modules/sidebar',['require','exports','module','underscore','marionette','../mixins/component.mixin','../mixins/sidebar.mixin'],function(require, exports, module){
  var _              = require('underscore');
  var Mn             = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var SidebarMixin   = require('../mixins/sidebar.mixin');


  var Sidebar = Mn.ItemView.extend(ComponentMixin).extend(SidebarMixin).extend({

    className: 'ui sidebar',

    template: function() { return '<ui name="contentView" />'; },

    options: {
      color: 'white',
      insertToBody: true,
      size: null,
      visible: false,
      direction: 'right',
      transition: 'overlay',
      dimPage: true,
      padded: true,
      width: '', //wide, thin or '' (for normal)
      preventUnsavedChanges: false
    },

    internalViewOptions: {
      contentView: {
        // define in extended view
      }
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      SidebarMixin.initialize.apply(this, arguments);
    },

    updateAttributes: function() {
      this
        .addClass(this.getOption('direction'), this.getBoolOption('direction'))
        .addClass(this.getOption('size'), this.getBoolOption('size'))
        .addClass(this.getOption('color'), this.getBoolOption('color'))
        .addClass(this.getOption('width'), this.getBoolOption('width'))
        .addClass('padded', this.getBoolOption('padded'));
    }

  });
  module.exports = Sidebar;
});

